var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { components } from 'react-select';
import styled from 'styled-components';
import CheckBox from '../../../CheckBox';
var OptionWithCheckbox = function (props) {
    var _a;
    var children = props.children, onClick = props.onClick, indeterminate = props.indeterminate, rest = __rest(props, ["children", "onClick", "indeterminate"]);
    var isSelected = rest.isSelected, isDisabled = rest.isDisabled;
    var value = (_a = props) === null || _a === void 0 ? void 0 : _a.value;
    return (_jsx(components.Option, __assign({}, rest, { children: _jsx(OptionWrapper, __assign({ "data-testid": value }, { children: _jsx(StyledCheckBox, __assign({ checked: isSelected, onChange: function (value) { return onClick === null || onClick === void 0 ? void 0 : onClick(value); }, disabled: isDisabled, indeterminate: indeterminate }, { children: children }), void 0) }), void 0) }), void 0));
};
export var OptionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  width: 100%;\n"], ["\n  display: flex;\n  cursor: pointer;\n  width: 100%;\n"])));
export var StyledCheckBox = styled(CheckBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 5px;\n  width: 100%;\n"], ["\n  margin-right: 5px;\n  width: 100%;\n"])));
export default OptionWithCheckbox;
var templateObject_1, templateObject_2;
